export function accordion() {
    const accordionBlock = $(".accordion");
    accordionBlock.on("click", ".heading", function (e) {
        const accordion = $(this).parents(".accordion");
        const parent = $(this).parent();
        const image = parent.find('.image');
        if (parent.hasClass("opened")) {
            if (!accordionBlock.parent().hasClass('accordion-wrap')) {
                parent.removeClass("opened").find(".hidden-info").slideUp();
            }
        } else {
            accordion.find(".accordion-item").removeClass("opened").find(".hidden-info").slideUp();
            parent.addClass("opened").find(".hidden-info").slideDown();
            accordion.find(".image").removeClass("showed");
            if (image) {
                image.removeClass('showed');
                setTimeout(() => {
                    image.addClass('showed');
                }, 400);
            }
        }
        e.preventDefault();
    });

    accordionBlock.each(function () {
        const $this = $(this);
        setTimeout(() => {
            if (!$this.find(".accordion-item:first-child").hasClass("opened")) {
                $this.find(".accordion-item:first-child .heading").trigger('click');
            }
        }, 100);
    });
}


export function accordionKMDG() {
    $('.single_accordion .single_accordion__header').on('click', function () {
        var $column = $(this).parent();

        $column.toggleClass('open');
        $column.find('.single_accordion__inner').slideToggle({
            duration: 250,
            progress: function () {
                $(window).trigger('resize');
            }
        });
    });
}


export function accordionKMDGYoast() {
    $('.wp-block-yoast-seo-table-of-contents.yoast-table-of-contents > :first-child').on('click', function () {
        var $column = $(this).parent();

        $column.toggleClass('open');
        $column.find('ul').slideToggle({
            duration: 250,
            progress: function () {
                $(window).trigger('resize');
            }
        });
    });
}

export function stickyToc(){
    $('.wp-block-yoast-seo-table-of-contents.yoast-table-of-contents').insertBefore('.article-holder > .article')

    $('.wp-block-yoast-seo-table-of-contents.yoast-table-of-contents').parent().addClass('sticky-table')
    if (window.matchMedia('(max-width: 1024px)').matches) {
        $('.wp-block-yoast-seo-table-of-contents.yoast-table-of-contents > :first-child').on('click', function () {
            var $column = $(this).parent();

            $column.toggleClass('open');
            $column.find('ul').slideToggle({
                duration: 250,
                progress: function () {
                    $(window).trigger('resize');
                }
            });
        });    } else {
        //...
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js